import TopBanner from "../StylisticComponents/TopBanner";

function Contact(){
    return (
        <div>
            <TopBanner>
                <h1 className="display-4 white-text hind-mysuru-bold">Get In Touch</h1>
                
                <p className="main-font description-text white-text">Book a free, no-obligation meeting with our team. We’re happy to provide advice, and discuss how we can help your business succeed.</p>
                <a href="https://calendly.com/abdullahyousuf225/30min" target="_blank" rel="noreferrer" className="contact-button orange-text">Schedule a Meeting</a>
            </TopBanner>
            <div className="pt-5" style={{ display: "block"}}>
                <div className="sidebar-container">
                    <div className="sidebar left blue-bg">
                        <h1 className="bebas-neue-regular white-text">Let's Talk</h1>
                        <p className="main-font description-text white-text">info@maplemarkmedia.com &bull; 416-477-6518 &bull; 4226 Duke of York Blvd Mississauga, ON L5B 0G5</p>
                        <form action={"https://formsubmit.co/info@maplemarkmedia.com"} method="POST">
                            <input type="hidden" name="_subject" value="[ Inquiry ] New Contact Form Submission" />
                            <input type="text" name="name" placeholder="Your Name" required className="form-control mb-3 main-font" />
                            <input type="email" name="email" placeholder="Your Email" required className="form-control mb-3 main-font" />
                            <textarea name="message" placeholder="Your Message" required className="form-control mb-3 main-font"></textarea>
                            <button type="submit" className="btn btn-primary main-font email-submit">Send Message</button>
                        </form>
                    </div>
                </div>
                <div className="sidebar-container">
                    <div className="sidebar right orange-bg">
                        <h1 className="bebas-neue-regular white-text">We're Everywhere</h1>
                        <div className="row">
                            <div className="col">
                                <a href="https://www.facebook.com/people/Maplemark-Media/61560179055036/" target="_blank" rel="noreferrer" className="social-link"><i className="fab fa-facebook-f"></i></a>
                            </div>
                            <div className="col">
                                <a href="https://x.com/MaplemarkMedia" target="_blank" rel="noreferrer" className="social-link"><i className="fab fa-x-twitter"></i></a>
                            </div>
                            <div className="col">
                                <a href="https://www.instagram.com/maplemarkmedia/" target="_blank" rel="noreferrer" className="social-link"><i className="fab fa-instagram"></i></a>
                            </div>
                            <div className="col">
                                <a href="https://www.linkedin.com/company/maplemarkmedia/" target="_blank" rel="noreferrer" className="social-link"><i className="fab fa-linkedin"></i></a>
                            </div>
                            <div className="col">
                                <a href="https://www.youtube.com/channel/UC8ZegkVW9wj_1logTFKWERw" target="_blank" rel="noreferrer" className="social-link"><i className="fab fa-youtube"></i></a>
                            </div>
                            <div className="col">
                                <a href="https://www.tiktok.com/@maplemarkmedia" target="_blank" rel="noreferrer" className="social-link"><i className="fab fa-tiktok"></i></a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Contact;